import { useRef } from "react";

import { useQueryClient } from "components/QueryClient";

export function useRequest(queryFactory, cached = false) {
  const client = useQueryClient();
  const clearCacheRef = useRef(() => {});

  const req = async (variables) => {
    const { result, clearCache } = await client.query(
      variables,
      queryFactory(),
      !cached
    );

    clearCacheRef.current = clearCache;

    return result;
  };

  return { req: req, clearCache: clearCacheRef.current || (() => {}) };
}

export default useRequest;
